"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Secrets_1 = __importDefault(require("../Secrets"));
const Config_1 = __importDefault(require("../../config/Config"));
const Logger_1 = require("../../utils/Logger");
const MetaValidator_1 = __importDefault(require("../../utils/MetaValidator"));
const ValueResolver_1 = require("../ValueResolver");
const Container_1 = require("../Container");
function Inject(definition, name, descriptor, params = {}) {
    if (typeof definition === 'string') {
        if (arguments.length > 1) {
            (0, Logger_1.error)('@Inject should receive only one argument.');
        }
        definition = { name: definition };
    }
    const paramsValidator = MetaValidator_1.default.create().str('name', Config_1.default.isStrict()).bool('eager').validator();
    const validate = MetaValidator_1.default.validateDecorator(Inject, paramsValidator, definition, params);
    if (validate) {
        return validate;
    }
    if (params.eager) {
        Secrets_1.default.setEager(definition, name);
    }
    function get() {
        const container = (0, Container_1.getContainer)(this);
        if (!container) {
            (0, Logger_1.error)(`There is no container at '${definition}'.`);
        }
        const injectableName = params.name || name;
        let resolver = container.provide(injectableName);
        if (resolver) {
            const value = resolver.get(this);
            const isFinal = (resolver instanceof ValueResolver_1.FinalValueResolver);
            const newDescriptor = isFinal ? { value } : { get: () => resolver.get(this) };
            Object.defineProperty(this, name, newDescriptor);
            return value;
        }
    }
    return { get };
}
exports.default = Inject;
//# sourceMappingURL=Inject.js.map